import React, { Component } from "react";
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { Redirect } from 'react-router-dom';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

import CustomTableFilter from '../components/Table_Filter';
import CustomTableCell from '../components/Table_Cell';


import * as CD from '../styles/Display_Styles';
import * as RA from '../actions/RollBarActions';
import rollBarStore from '../stores/RollBarStore';


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 200,
    },
    tableWrapper: {
        overflowX: 'auto'
    },
    center: {
        textAlign: 'center'
    },
    right: {
        position: 'absolute',
        right: '0px'
    },
    select: {
        marginRight: '8px'
    },
    loading: {
        position: 'absolute',
        right: '60px'
    }
});



class RollBarDisplay extends Component {
    constructor(props) {
        super(props);
        this.getAdvancedRollBarStore = this.getAdvancedRollBarStore.bind(this);
        const { columns, ticketsDisplay, meta, sort } = rollBarStore.getAll();

        this.state = {
            columns,
            ticketsDisplay,
            meta,
            sort,
        };

    }

    // --- HOOKS ---

    componentDidMount() {
        RA.updateTickets(this.props.location);
        rollBarStore.on('change', this.getAdvancedRollBarStore);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            let newMeta = this.state.meta;
            newMeta.loading = true;
            this.setState({meta: newMeta});
            RA.updateTickets(nextProps.location);
        }
    }

    componentWillUnmount() {
        rollBarStore.removeListener('change', this.getAdvancedRollBarStore);
    }

    // --- FLUX ---

    getAdvancedRollBarStore = () => {
        const { columns, ticketsDisplay, meta } = rollBarStore.getAll();
        this.setState({
            columns,
            ticketsDisplay,
            meta
        })
    }

    // --- EVENTS ---

    handleChangePage = (event, page) => {
        let meta = this.state.meta;
        meta.page = page;
        RA.updateMeta(meta);
    }

    handleChangeRowsPerPage = (event) => {
        let meta = this.state.meta;
        meta.rowsPerPage = event.target.value;
        RA.updateMeta(meta);
    }

    handleSort = property => event => {
        RA.updateSort({ event, property })
    };

    // --- HELPERS ---

    // --- COMPONENTS ---

    loading = () => {
        const { loading } = this.state.meta;

        if (loading) {
            return (
                <CircularProgress
                    size={25}
                ></CircularProgress>
            )
        } else {
            return (null);
        }
    }

    noResults = () => {
        const { columns } = this.state;
        const { classes } = this.props;

        const columnLength = columns.length;
        return (
            <TableRow>
                <TableCell className={classes.center} colSpan={columnLength}>
                    NO RESULTS FOUND FOR PROVIDED FILTER
                </TableCell>
            </TableRow>
        )
    }

    // --- RENDER ---

    render() {
        window.cd = this.state;

        const { ticketsDisplay, columns } = this.state;
        const { rowsPerPage, page, authentication, loading } = this.state.meta;
        const { order, orderBy } = this.state.sort;
        const { classes, location } = this.props;

        if (!authentication) {
            return (
                <Redirect
                    to={{
                        pathname: location.pathname,
                        search: location.search
                    }}
                />
            )
        }

        const noResults = (ticketsDisplay.length === 1 && ticketsDisplay[0].id === 'NA' && !loading)
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, ticketsDisplay.length - page * rowsPerPage);

        return (
            <Paper className={classes.root}>
                <Toolbar
                    className={classNames(classes.root)}
                    disableGutters={true}
                >
                    <div>
                        <TablePagination
                            component="div"
                            count={ticketsDisplay.length}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[5, 10, 25, 100]}
                            page={page}
                            classes={{ selectRoot: classes.select }}
                            labelRowsPerPage={''}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                    <div className={classes.right}>
                        <Tooltip title="Filter list">
                            <CustomTableFilter location={this.props.location} />
                        </Tooltip>
                    </div>
                    <div className={classes.loading}>
                        {this.loading()}
                    </div>
                </Toolbar>
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <TableHead>
                            <TableRow>
                                {columns.map(column => {
                                    return (
                                        <TableCell
                                            key={column.id}
                                            numeric={column.numeric}
                                            padding={column.disablePadding ? 'none' : 'default'}
                                            sortDirection={orderBy === column.id ? order : false}
                                            className='column'
                                            style={CD.getColumnStyle(column.id)}
                                        >
                                            {column.sort && (() => {
                                                return (
                                                    <Tooltip
                                                        title="Sort"
                                                        placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                                        enterDelay={300}
                                                    >
                                                        <TableSortLabel
                                                            active={orderBy === column.id}
                                                            direction={order}
                                                            onClick={this.handleSort(column.id)}
                                                        >
                                                            {column.label}
                                                        </TableSortLabel>
                                                    </Tooltip>
                                                )
                                            })()}
                                            {!column.sort && (() => column.label)()}
                                        </TableCell>
                                    );
                                }, this)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!noResults && ticketsDisplay
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(defect => {
                                    const rowStyle = CD.getRowStyle(defect.status.sort);
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={defect.id}
                                            style={rowStyle}
                                        >
                                            {columns.map((column) => {
                                                const id = `${defect.id}${column.id}`;
                                                return (
                                                    <CustomTableCell
                                                        key={id}
                                                        data={defect}
                                                        column={column.id}
                                                    ></CustomTableCell>
                                                )
                                            })}
                                        </TableRow>
                                    );
                                })
                            }
                            {noResults && this.noResults()}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 49 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
            </Paper>
        );
    }
}


export default withStyles(styles)(RollBarDisplay);


// WEBPACK FOOTER //
// ./src/js/components/RollBar_Display.js